import { DELETE_DATA, SET_EMPLOYEE_UPLOAD_FILES, SET_ORGANISATION_UPLOAD_FILES, GLOBAL_DATA, SET_ORGANISATION_DROPDOWN_VALUES, SET_EMPLOYEE_DROPDOWN_VALUES, TOGGLE_GROWING_LIST_POPUP, ACCESS_PERMISSION, SEARCH_VALUE } from './actions';
import { accessPermissionConstant, fetchLevelAccess } from '../Common/constant';

const intialState = {
  email: "",
  token: "",
  role: "",
  jobRole: "",
  name: "",
  organisationDropdowns: [],
  organisationUploads: [],
  employeeDropdowns: [],
  partnerDropdowns: [],
  employeeUploads: [],
  showGrowingDropdownModal: false,
  accessLevel: "",
  accessPermission: undefined,
  next_available_date: "",
  searchValue: "",
  // authorization_headers:undefined,

  ...fetchLevelAccess(),
};
const commonReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case GLOBAL_DATA:
      return Object.assign({}, state, action.payload);
    case ACCESS_PERMISSION:
      const accessPermission: any = (accessPermissionConstant as any)[action.payload ? action.payload.toLowerCase() : 'admin']
      return {
        ...state,
        accessPermission
      };
    case DELETE_DATA:
      return intialState;
    case SET_ORGANISATION_DROPDOWN_VALUES:
      return { ...state, organisationDropdowns: action.payload };
    case SET_ORGANISATION_UPLOAD_FILES:
      return { ...state, organisationUploads: action.payload };
    case SET_EMPLOYEE_DROPDOWN_VALUES:
      return { ...state, employeeDropdowns: action.payload };
    case SET_EMPLOYEE_UPLOAD_FILES:
      return { ...state, employeeUploads: action.payload };
    case TOGGLE_GROWING_LIST_POPUP:
      return { ...state, showGrowingDropdownModal: action.payload }
      case SEARCH_VALUE: 
      return {...state, searchValue: action.payload}
    default:
      return state;
  }
};
export default commonReducer;
